@if (data?.value; as value) {
    <div>
        <h3>Name of the value</h3>
        <dx-text-box #focus
                     [(value)]="value.name"
                     (valueChange)="validateEntities()"
                     placeholder="Enter value name"
                     data-test="value-name-input">
            <dx-validator>
                <dxi-validator-validation-rule [adaptEntity]="value"
                                               adaptEntityProperty="name"></dxi-validator-validation-rule>
                <dxi-validator-validation-rule [adaptEntity]="value"
                                               [adaptBreezeValidator]="uniqueValueNameValidator"></dxi-validator-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
}
